import PercentageTypes from './percentage.types';

export const setCallPercentage = (data) => ({
  type: PercentageTypes.SET_CALL_PERCENTAGE,
  payload: data,
});
